import { BaseResponse } from "../BaseResponse";
import { details } from "./details";

export class detailsresponse extends BaseResponse{
    public detail: any[] = [];

}